import { generateInvoiceEntry } from './generateInvoiceEntry.js'; // ✅ Invoice trigger added

export const recordPayment = async ({
  tenantId,
  companyName,
  email,
  amount,
  currency,
  method,
  billingCycle,
  annualDiscountRate,
  selectedModules
}) => {
  try {
    const timestamp = new Date().toISOString(); // 🔒 Anchored for invoice use

    const paymentLog = {
      tenantId,
      companyName,
      email,
      amount,
      currency,
      method,
      billingCycle,
      annualDiscountRate,
      selectedModules,
      timestamp
    };

    console.log('Recording payment:', paymentLog);

    // 🔹 Write audit-safe entries per module
    const auditKey = `paymentAuditLog_${email}`;
    const existingLogs = JSON.parse(localStorage.getItem(auditKey)) || [];

    const now = new Date();
    const purchaseDate = now.toLocaleString('en-BD', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

    const startDate = purchaseDate;

    const expiryDateObj = new Date(now);
    if (billingCycle === 'monthly') {
      expiryDateObj.setMonth(expiryDateObj.getMonth() + 1);
    } else if (billingCycle === 'annual') {
      expiryDateObj.setFullYear(expiryDateObj.getFullYear() + 1);
    }
    const expiryDate = expiryDateObj.toLocaleString('en-BD', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

    const invoiceNo = `INV${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

    selectedModules.forEach((mod) => {
      const moduleName = mod.name || mod.moduleName || mod.id || 'Unknown Module';
      const basePrice = mod.price || mod.amount || amount || 0;

      const auditEntry = {
        companyName,
        tenantId,
        email,
        moduleName,
        paymentStatus: 'paid',
        purchaseDate,
        startDate,
        expiryDate,
        billingCycle,
        amount: basePrice,
        currency,
        method,
        invoiceNo, // ✅ Enables preview hydration
        annualDiscountRate: billingCycle === 'annual' ? annualDiscountRate : 0 // ✅ Canonical field only
      };

      existingLogs.push(auditEntry);
    });

    localStorage.setItem(auditKey, JSON.stringify(existingLogs));

    // 🔹 Trigger invoice generation per module
    generateInvoiceEntry({
      tenantId,
      companyName,
      email,
      currency,
      method,
      billingCycle,
      annualDiscountRate,
      selectedModules,
      timestamp,
      invoiceNo // ✅ Enables preview hydration
    });

    // 🔹 Simulate tenant activation
    console.log(`✅ Tenant ${tenantId} activated for ${companyName}`);

    return { status: 'logged_and_activated', invoiceNo };
  } catch (error) {
    console.error('Payment logging failed:', error);
    return { status: 'error', message: error.message };
  }
};
